@if (!isAuthenticated) {
  <app-loading></app-loading>
}
@if (isAuthenticated) {
  <app-authenticated></app-authenticated>
}
@if (offlineAlertVisible) {
  <app-banner [useOverlay]="true" bgColorClass="error" message="Your device is offline. Please check your internet connection to continue using this app"></app-banner>
}
@if (errorAlertVisible) {
  <app-banner [useOverlay]="true" bgColorClass="error" message="The application has encountered an issue and is unable to load. You can try reloading or contact support." primaryActionText="Contact Support" secondaryActionText="Reload" (primaryAction)="reload()" (secondaryAction)="reload()"></app-banner>
}
@if (updateAlertVisible) {
  <app-banner bgColorClass="dark" message="This application has been updated. Please reload to get the latest features." primaryActionText="Reload" secondaryActionText="Dismiss" (primaryAction)="reload()" (secondaryAction)="updateAlertVisible=false"></app-banner>
}
